import React from "react";

function Navbar() {
  const toggleNavbar = () => {
    const navbar = document.querySelector("nav .list-item");
    navbar.classList.toggle("nav-active");
  };


  return (
    <nav className="row nav_scrolled">
      <div className="nav-nav ">
        <div className="brand_name">
          <h2>
            <a href="/">Danny Quan</a>
          </h2>
        </div>
        {/*dark background here */}
        <ul className="list-item">
          <li >
            <a href="index.html">Home</a>
          </li>
          <li onClick={toggleNavbar}>
            <a href="#section-about">About</a>
          </li>
          <li onClick={toggleNavbar}>
            <a href="#service-section">Service</a>
          </li>
          <li onClick={toggleNavbar}>
            <a href="#contact-section">Contact Me</a>
          </li>
        </ul>
        <div className="hamburger" onClick={toggleNavbar}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
